import { Operation } from 'views/ResourceMapper/types';

export function getAreaTotalFromOperation(operation: Operation) {
  const filtered = operation?.task_measures?.filter(
    (measure: any) =>
      measure.dtr_code === 'A_AREA_ALLOCATED' || measure.dtr_code === 'A_AREA_TOTAL',
  );
  return filtered?.[0];
}
